import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_thi_68aa6283c9: FaireThemeEntity = {
  token: "board_demo_r_9rhufegspe_thi_68aa6283c9",
  type: "theme",
  retailerToken: "r_9rhufegspe",
  name: "Jersey City Spring Handmade Market Selection",
  description:
    "Curated artisanal and hand-painted goods, including ceramic vases and hair clips, perfectly suited for your upcoming presence at the Jersey City Spring Handmade Markets.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/d0875054da2d8da14e23739b4d24c2e59e9c78655311cd948acce9be564e3226.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/d0875054da2d8da14e23739b4d24c2e59e9c78655311cd948acce9be564e3226.jpeg",
    "https://cdn.faire.com/fastly/e58ac3a4e3f63f13b114e83d3d52e59042096e569096d8a47c1a51cfb892d851.jpeg",
    "https://cdn.faire.com/fastly/ec5516ebf63d43edf8927701c3831f56f587cb64d8d0a227968fa0f6bdb3d835.jpeg",
    "https://cdn.faire.com/fastly/cdd95f0c7d02f49ea3418a580ef7977d47cce3b07d0e2b43b4b8a3376eee4a8f.jpeg",
    "https://cdn.faire.com/fastly/357f507398f6af6f7582d0b1ac2998b636dab794034a3da635ff4e9353ca2de9.png",
    "https://cdn.faire.com/fastly/bd549b686b4591a51528d834e85ff719a4af011a7bfc97aee8ff12191fc3e24f.jpeg",
  ],
  itemCount: 69,
  source: "eric_themes_ideas",
  teaser: "thi_68aa6283c9",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
